import React, { useContext, useEffect, useRef, useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import { Tooltip } from "@material-ui/core";
import {
  CardsWrapper,
  GeneralStyle,
  ContentModalInfo,
  CloseModalInfo,
  TextModalInfo,
  ButtonInfo,
  TableViewButton,
  SearchField,
  ActionTooltipContainer,
  useStyles,
} from "./NewFormsManagement.styled";
import HeaderComponent from "../Header/Header";
import { ReactComponent as SurveyManagementIcon } from "../../assets/svg/survey-management-icon.svg";
import { ContextQuestions } from "../../Store/StoreQuestions";
import Card from "../../components/ConfigurationCards";
import PubSub from "pubsub-js";
import FormList from "../FormsList/FormList";
import SurveyCategories from "../SurveyCategories";
import QuestionCategories from "../QuestionCategories";
import PortalModal from "../../Portals";
import SurveyForm from "../SurveyCreationForm/SurveyCreationForm";
import SearchIcon from "@material-ui/icons/Search";
import { theme as themeConfig } from "../../themes/themes";
import InfoIcon from "@material-ui/icons/Info";
import CategoriesForm from "../CategoriesCreationForm/CategoriesForm";
import Paper from "@material-ui/core/Paper";
import { AntTab, AntTabs } from "../../helpers/antTabs";
import ViewList from "@material-ui/icons/ViewList";
import ViewCards from "@material-ui/icons/ViewModule";
import { AntSwitch } from "../../helpers/antSwitch";
import { ROLES } from "../../util/RolesConstants";
import Button from "@material-ui/core/Button";
import { Form } from "react-bootstrap";
import { Clear } from "@material-ui/icons";
import SurveyCreationMain from "../../containers/SurveyCreationMainPage/SurveyCreationMain";
import ModalLoader from "../ModalLoader/ModalLoader";
import { useLocation } from "react-router-dom";
import { useQuery } from "@apollo/client";
import {
  ALL_SURVEY_CATEGORIES,
  CURRENT_USER_INFO,
} from "../../GraphQL/Queries";
import { getStateLoginComplete } from "../../containers/LayoutHome/stateLogin";

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: themeConfig.neutral.gray[2500],
    color: "white",
    padding: "1em 1em 1em 0",
    border: "1px solid #dadde9",
    width: "auto",
  },
}))(Tooltip);

const NewFormsManagement = () => {
  const [updateData, setupdateData] = useState({});
  const [, dispatch] = useContext(ContextQuestions);
  const [selectedMenu, selectMenu] = useState(["new", "New Survey"]);
  const [formTrigger, setFormTrigger] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [ShowSurveyCreationMain, setShowSurveyCreationMain] = useState({
    idSurvey: 0,
    isIntegrated: false,
    isEditSurvey: false,
    dataEditSurvey: null,
    show: false,
    OnlyAssigned: false,
    onlyReviewWithComments: false,
  });
  const [user] = useState(getStateLoginComplete());
  const { data } = useQuery(ALL_SURVEY_CATEGORIES);
  const [activeAll, setActiveAll] = useState(true);
  const [showCards, setShowCards] = useState(true);
  const [searchTxt, setSearchTxt] = useState("");
  const rSearch = useRef();

  const classes = useStyles();
  const [valueTabs, setValueTabs] = useState(0);

  const { data: userdata } = useQuery(CURRENT_USER_INFO, {
    variables: { userId: user.userId },
    context: { clientName: "LinkUsers" },
  });

  const location = useLocation();
  const [surveyEdit, setSurveyEdit] = useState();

  useEffect(() => {
    if (location?.state?.idSurvey) {
      setSurveyEdit(location.state.idSurvey);
    }
  }, [location?.state?.idSurvey]);

  useEffect(() => {
    PubSub.subscribe("dataEditSurveyCreationMain", (e, data) => {
      setShowSurveyCreationMain({
        idSurvey: data.idSurvey,
        isIntegrated: false,
        isEditSurvey: true,
        show: true,
        dataEditSurvey: data?.data,
      });
    });
    dispatch({ type: "CLEAN_QUESTIONS" });
    dispatch({ type: "CLEAN_STYLES" });
    return () => {
      PubSub.unsubscribe("dataEditSurveyCreationMain");
    };
  }, []);

  useEffect(() => {
    if (formTrigger !== selectedMenu[0]) {
      setFormTrigger("");
    }
    if (formTrigger === selectedMenu[0]) {
      setFormTrigger(selectedMenu[0]);
    }
  }, [formTrigger, selectedMenu]);

  const getDataBySearch = () => {
    setSearchTxt(rSearch?.current?.value);
  };

  const applySearchOnBreak = () => {
    let timer;
    return function () {
      let context = this;
      clearTimeout(timer);
      timer = setTimeout(() => {
        getDataBySearch.apply(context, arguments);
      }, 500);
    };
  };

  const handleSearch = applySearchOnBreak();

  let showSelectedMenu = () => {
    switch (selectedMenu[0]) {
      case "new":
        return (
          <Card
            activeicon={true}
            icon="plus"
            iconplusactive={false}
            coloricon={themeConfig.neutral.white}
            colorBorder={themeConfig.neutral.white}
            code="new"
            title="Create Form"
            subtitle="form creation with different question style"
            footerText="Create new FORM now"
            setFormTrigger={setFormTrigger}
          />
        );
      case "survey":
        return (
          <Card
            activeicon={true}
            icon="plus"
            iconplusactive={false}
            coloricon={themeConfig.neutral.white}
            colorBorder={themeConfig.neutral.white}
            code="survey"
            title="Form Category"
            subtitle="Category Administration"
            footerText="New form category"
            setFormTrigger={setFormTrigger}
          />
        );
      case "question":
        return (
          <Card
            activeicon={true}
            icon="plus"
            iconplusactive={false}
            coloricon={themeConfig.neutral.white}
            colorBorder={themeConfig.neutral.white}
            code="question"
            title="Question Category"
            subtitle="Category Administration"
            footerText="New question category"
            setFormTrigger={setFormTrigger}
          />
        );
      default:
        break;
    }
  };

  let showSelectedMenuTable = () => {
    switch (selectedMenu[0]) {
      case "new":
        return (
          <FormList
            setShowSurveyCreationMain={setShowSurveyCreationMain}
            formTrigger={formTrigger}
            showCards={showCards}
            setShowCards={setShowCards}
            activeApprovalsRequested={null}
            activeUnderApproval={null}
            activeAll={activeAll}
            searchBy={searchTxt}
            surveyEdit={surveyEdit}
            sortingColumns={true}
            itsSurvey={false}
          />
        );
      case "survey":
        return (
          <SurveyCategories
            formTrigger={formTrigger}
            setFormTrigger={setFormTrigger}
            setupdateData={setupdateData}
            showCards={showCards}
            searchBy={searchTxt}
            setShowCards={setShowCards}
          />
        );
      case "question":
        return (
          <QuestionCategories
            formTrigger={formTrigger}
            setFormTrigger={setFormTrigger}
            setupdateData={setupdateData}
            showCards={showCards}
            searchBy={searchTxt}
            setShowCards={setShowCards}
          />
        );
      default:
        break;
    }
  };

  let showCategoryForm = () => {
    switch (formTrigger) {
      case "new":
        return (
          <PortalModal>
            {data?.allCategoriesSurvey.outputData.length ? (
              <SurveyForm
                user={user}
                setShowSurveyCreationMain={setShowSurveyCreationMain}
                setFormTrigger={setFormTrigger}
                userdata={userdata}
                setShowLoader={setShowLoader}
                itsForm={true}
              />
            ) : (
              <ContentModalInfo>
                <CloseModalInfo>
                  <span onClick={() => setFormTrigger("")}>X</span>
                </CloseModalInfo>
                <TextModalInfo>
                  <InfoIcon />
                  <p>
                    There are no question form categories created. Please create
                    at least one to proceed to create form.
                  </p>
                </TextModalInfo>
                <div
                  style={{
                    display: "inline-flex",
                    margin: "auto",
                    width: "100%",
                  }}
                >
                  <ButtonInfo onClick={() => setFormTrigger("")}>
                    Ok
                  </ButtonInfo>
                </div>
              </ContentModalInfo>
            )}
          </PortalModal>
        );
      case "survey":
        return (
          <PortalModal>
            <CategoriesForm
              setupdateData={setupdateData}
              updateData={updateData}
              formTrigger={formTrigger}
              title={
                updateData.idCategorySurvey
                  ? "Update form category"
                  : "New form category"
              }
              setFormTrigger={setFormTrigger}
            />
          </PortalModal>
        );
      case "question":
        return (
          <PortalModal>
            <CategoriesForm
              setupdateData={setupdateData}
              updateData={updateData}
              formTrigger={formTrigger}
              title={
                updateData.idCategoryQuestion
                  ? "Update question category"
                  : "New question category"
              }
              setFormTrigger={setFormTrigger}
            />
          </PortalModal>
        );
      default:
        break;
    }
  };

  const resetSearchString = () => {
    setSearchTxt("");
    if (rSearch?.current) rSearch.current.value = "";
  };

  return (
    <>
      {!ShowSurveyCreationMain.show && (
        <GeneralStyle>
          <HeaderComponent
            Icon={SurveyManagementIcon}
            text={"Forms Management"}
          ></HeaderComponent>
          {user && user.roleId !== ROLES.AGENT ? (
            <h1>{/* selectedMenu[1] */}</h1>
          ) : (
            <h1>Available Surveys</h1>
          )}
          {user && user.roleId !== ROLES.AGENT && (
            <div className={classes.root}>
              <Paper position="static" style={{ borderRadius: "0px" }}>
                <AntTabs aria-label="Manage Survey" value={valueTabs}>
                  <AntTab
                    label="Forms"
                    id="new"
                    onClick={() => {
                      selectMenu(["new", "New Survey"]);
                      setValueTabs(0);
                      setShowCards(true);
                      resetSearchString();
                    }}
                  />
                  <AntTab
                    label="Form Category"
                    id="form"
                    onClick={() => {
                      selectMenu(["survey", "Survey Categories"]);
                      setValueTabs(1);
                      setShowCards(true);
                      resetSearchString();
                    }}
                  />
                  <AntTab
                    label="Question Category"
                    id="question"
                    onClick={() => {
                      selectMenu(["question", "Question Categories"]);
                      setValueTabs(2);
                      setShowCards(true);
                      resetSearchString();
                    }}
                  />
                </AntTabs>
              </Paper>
              <CardsWrapper className="pt-3 pb-2" valueTabs={valueTabs}>
                {showSelectedMenu()}
                {valueTabs !== 2 && <div style={{ margin: "0 auto" }}></div>}
                {valueTabs !== 3 && (
                  <div className="right-section">
                    <SearchField>
                      <SearchIcon style={{ color: themeConfig.text.primary }} />
                      <Form.Control
                        type="text"
                        placeholder="Search"
                        onChange={handleSearch}
                        ref={rSearch}
                      />
                      <Clear
                        style={{
                          right: "0",
                          color: themeConfig.neutral.gray[2600],
                          width: "1rem",
                          height: "1rem",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          rSearch.current.value = "";
                          setSearchTxt("");
                        }}
                      />
                    </SearchField>
                    <div className="table-action">
                      <Tooltip title="View List">
                        <TableViewButton
                          iconColor={showCards}
                          onClick={() => setShowCards(false)}
                          className="MuiButtonBase-root MuiIconButton-root"
                        >
                          <span
                            style={{ width: "fit-content" }}
                            className="MuiIconButton-label"
                          >
                            <ViewList className="list-view" />
                          </span>
                        </TableViewButton>
                      </Tooltip>
                      <Tooltip title="View Cards">
                        <TableViewButton
                          iconColor={showCards}
                          onClick={() => setShowCards(true)}
                          style={{ borderLeft: "none" }}
                          className="MuiButtonBase-root MuiIconButton-root"
                        >
                          <span
                            style={{ width: "fit-content" }}
                            className="MuiIconButton-label"
                          >
                            <ViewCards className="card-view" />
                          </span>
                        </TableViewButton>
                      </Tooltip>
                    </div>
                  </div>
                )}
              </CardsWrapper>
              <div
                style={{
                  width: "100%",
                  textAlign: "right",
                  paddingRight: "1.5rem",
                }}
              >
                {showCards && valueTabs === 0 && (
                  <HtmlTooltip
                    arrow
                    placement="top"
                    title={
                      <ActionTooltipContainer>
                        <Button className="tooltip-btn disabled-btn">
                          Activate
                        </Button>
                        <label>Inactive form</label>
                        <Button className="tooltip-btn">Activate</Button>
                        <label>Ready to activate</label>
                        <AntSwitch size="small" checked={false} />
                        <label style={{ marginBottom: "0.5rem" }}>
                          Disable form
                        </label>
                        <AntSwitch size="small" checked={true} />
                        <label>Enable form</label>
                      </ActionTooltipContainer>
                    }
                  >
                    <div style={{ display: "inline", width: "auto" }}>
                      <InfoIcon />
                      <label>Actions</label>
                    </div>
                  </HtmlTooltip>
                )}
              </div>
            </div>
          )}
          {showSelectedMenuTable()}
          {showCategoryForm()}
        </GeneralStyle>
      )}
      {ShowSurveyCreationMain.show && (
        <SurveyCreationMain
          idSurvey={ShowSurveyCreationMain.idSurvey}
          isIntegrated={ShowSurveyCreationMain.isIntegrated}
          isEditSurvey={ShowSurveyCreationMain.isEditSurvey}
          dataEditSurvey={ShowSurveyCreationMain.dataEditSurvey}
          OnlyAssigned={ShowSurveyCreationMain.OnlyAssigned}
          onlyReviewWithComments={ShowSurveyCreationMain.onlyReviewWithComments}
          setShowSurveyCreationMain={setShowSurveyCreationMain}
        />
      )}
      {showLoader && <ModalLoader />}
    </>
  );
};

export default NewFormsManagement;
